module.exports = __webpack_public_path__ + "img/search.f63bbd49.svg";